/**
 * Downloads a file by creating a temporary anchor element
 */
export function downloadFile(url: string, filename: string, testId: string) {
  const a = document.createElement("a");
  a.href = url;
  a.setAttribute("data-testid", testId);
  a.download = filename;
  document.body.appendChild(a);

  // Allows the test to check if proper file would be downloaded
  new Promise<void>((resolve) => {
    a.click();
    resolve();
  }).finally(() => {
    document.body.removeChild(a);
  });
}
